<template>
    <footer class="bg-footer text-white py-4">
        <div class="container">
            <div class="row mt-5">
                <div class="col-md-4 mb-3">
                    <h5>ติดต่อนักลงทุนสัมพันธ์</h5>
                    <p class="text-footer m-0">โทรศัพท์ : 081-1311064</p>
                    <p class="text-footer m-0">โทรสาร : 02-3988066</p>
                    <p class="text-footer mb-5">อีเมล : ir@origin.co.th</p>

                    <a href="https://www.facebook.com/OriginVertical" target="_blank" class="text-white me-3"><i class="fab fa-facebook-f fa-1x"></i></a>
                    <a href="https://page.line.me/qep5866s?openQrModal=true" target="_blank" class="text-white me-3"><i class="fab fa-line fa-1x"></i></a>
                    <a href="https://www.instagram.com/origin_vertical/" target="_blank" class="text-white me-3"><i class="fab fa-instagram fa-1x"></i></a>
                    <a href="https://x.com/i/flow/login?redirect_after_login=%2FOrigin_vertical" target="_blank" class="text-white me-3"><i class="fab fa-twitter fa-1x"></i></a>
                    <a href="https://www.youtube.com/@origin_vertical" target="_blank" class="text-white me-3"><i class="fab fa-youtube fa-1x"></i></a>

                </div>
                <div class="col-md-3 mb-3">
                    <h5>สมัครติดตามข่าวสาร</h5>
                    <p class="text-footer">ท่านสามารถลงทะเบียนเพื่อรับข่าวสารอิเล็คทรอนิคส์
                        เราจะส่งข่าวสาร ให้ท่านทางอีเมลเมื่อมีข่าวสารทาง
                        บริษัทประกาศผ่านเว็บไซต์</p>
                    <button type="button" class="btn btn-outline-light w-100" @click="goToNews">สมัครรับข่าวสาร</button>
                </div>
                <div class="col-md-3 mb-3">
                    <h5>หน้าหลักนักลงทุนสัมพันธ์</h5>
                    <ul class="list-unstyled text-footer">
                        <li class="mb-2"><router-link to="/financialinfo/info"
                                class="text-white">ข้อมูลทางการเงิน</router-link></li>
                        <li class="mb-2"><router-link to="/stockpriceinfo/info"
                                class="text-white">ข้อมูลราคาหลักทรัพย์</router-link></li>
                        <li class="mb-2"><router-link to="/basicInfo/info" class="text-white">ข้อมูลผู้ถือหุ้น</router-link>
                        </li>
                        <li class="mb-2"><router-link to="/warrantholdersinfo"
                                class="text-white">ข้อมูลสำหรับผู้ถือใบสำคัญแสดงสิทธิ</router-link></li>
                        <li class="mb-2"><router-link to="/debtinfo/info" class="text-white">ข้อมูลตราสารหนี้</router-link>
                        </li>
                    </ul>
                </div>
                <div class="col-md-2 mb-3 mt-4">
                    <ul class="list-unstyled text-footer">
                        <!-- <li class="mb-2"><router-link to="/calendarinfo/info" class="text-white">ปฏิทินนักลงทุนสัมพันธ์</router-link>
                        </li> -->
                        <!-- <li class="mb-2"><router-link to="/newinfo/info" class="text-white">ห้องข่าว</router-link></li> -->
                        <!-- <li class="mb-2"><router-link to="/activityinfo"
                                class="text-white">กิจกรรมและเอกสารนำเสนอ</router-link></li> -->
                        <li class="mb-2"><router-link to="/publisheddocsinfo/info"
                                class="text-white">เอกสารเผยแพร่</router-link></li>
                        <!-- <li class="mb-2"><router-link to="/analystinfo" class="text-white">ข้อมูลนักวิเคราะห์</router-link>
                        </li> -->
                    </ul>
                </div>
            </div>
            <hr>
            <div class="row">
                <div class="col-md-8 text-copyright">
                    COPYRIGHT © 2019 , ORIGIN PROPERTY PUBLIC CO.,LTD ALL RIGHTS RESERVED.
                </div>
                <div class="col-md-1 text-end text-copyright">
                    <!-- แผนผังเว็บไซต์ -->
                </div>
                <div class="col-md-2 text-end text-copyright">
                    <!-- นโยบายความเป็นส่วนตัว -->
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    name: 'Footer',
    data() {
        return {};
    },
    methods: {
        goToNews() {
            this.$router.push('/informationinfo');
        },
    }
};
</script>

<style>
.bg-footer {
    background-color: #333333;
}

.text-copyright {
    font-size: 12px;
}

.text-footer {
    font-size: 13px;
}

.text-footer a,
.text-footer router-link {
    color: white;
    text-decoration: none;
}

.text-footer a:hover,
.text-footer router-link:hover {
    color: #E87D2E !important;
}
</style>
